import React from 'react'
import PropTypes from 'prop-types'
import { ConnectedRouter } from 'react-router-redux'
import routes from './routes'
import 'antd/dist/antd.css'
import Cookies from 'universal-cookie'

const cookies = new Cookies();

const App = ({ history }) => {
    if(!cookies.get('isConnected')) {
        cookies.set('isConnected', false);
    }
    return (
        <ConnectedRouter history={history}>
            { routes }
        </ConnectedRouter>
    )
}

App.propTypes = {
    history: PropTypes.object,
}

export default App
